import EventOutlinedIcon from "@mui/icons-material/EventOutlined";
import type { FC } from "react";
import { useTranslation } from "react-i18next";
import MetaChip from "../../../UIToolkit/Badges/MetaChip";
import type { ShownHolidayGroup } from "./scheduleHolidays";

type Props = {
	/** The applied group of the shift's holiday (from `holidayForShift`). Null once that group was removed. */
	group: ShownHolidayGroup | null;
	/** Icon only, with the words on hover: for a narrow timeline block, where the label would push the name out. */
	// DEFAULT: false, the icon and the words.
	compact?: boolean;
	dataTestId: string;
};

/** "Holiday · Group A" in the group's colour (or a plain "Holiday"), on a shift a holiday's Apply put on the schedule. */
export const HolidayShiftChip: FC<Props> = ({ group, compact = false, dataTestId }) => {
	const { t } = useTranslation();
	const label = group === null ? t("holidays.schedule.ribbon.label") : t("holidays.schedule.chip", { group: group.label });
	return (
		<MetaChip
			icon={<EventOutlinedIcon />}
			label={compact ? undefined : label}
			tooltip={compact ? label : undefined}
			tone="primary"
			customTone={group === null ? undefined : { ink: group.color.ink, bg: group.color.fill, border: group.color.dot }}
			dataTestId={dataTestId}
		/>
	);
};
